import React from "react";

import { css } from "@emotion/css";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { PeriodSelector, Periodicities, Periodicity } from "@/uiKit/molecules/period-picker/PeriodSelector.tsx";

type PeriodPickerProps = {
  current: Periodicity;
  periodicities: Periodicities;
  onChange: (args: Periodicity) => void;
};

export const PeriodPicker: React.FC<PeriodPickerProps> = ({ current, periodicities, onChange }) => {
  const styles = useStyles(makePeriodSelectorStyles);

  const handleChangePeriodicity = (periodicity: Periodicity) => {
    onChange(periodicity);
  };

  return (
    <div className={styles.container}>
      <PeriodSelector
        currentPeriodicity={current}
        periodicities={periodicities}
        onChangePeriodicity={handleChangePeriodicity}
      />
    </div>
  );
};

const makePeriodSelectorStyles = () => ({
  container: css`
    display: flex;
    align-items: center;
  `,
});

type SelectPeriodProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const SelectPreviousPeriod: React.FC<SelectPeriodProps> = ({ onClick }) => {
  const styles = useStyles(makeSelectPeriodStyles, false);
  return (
    <button data-action="monitoring.period.previous" className={styles.button} onClick={onClick}>
      <Icons.arrowLeft className={styles.icon} />
    </button>
  );
};

type SelectNextPeriodProps = SelectPeriodProps & {
  disabled: boolean;
};

export const SelectNextPeriod: React.FC<SelectNextPeriodProps> = ({ onClick, disabled }) => {
  const styles = useStyles(makeSelectPeriodStyles, disabled);

  return (
    <button data-action="monitoring.period.next" className={styles.button} disabled={disabled} onClick={onClick}>
      <Icons.arrowRight className={styles.icon} />
    </button>
  );
};

const makeSelectPeriodStyles = (theme: Theme, disabled: boolean) => ({
  button: css`
    background-color: ${theme.palette.common.white};
    padding: ${theme.spacing(6)};
    color: ${disabled ? theme.palette.grey[300] : theme.palette.text.primary};
    display: flex;
    height: fit-content;
  `,
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
